module.exports = __webpack_public_path__ + "static/img/10034.e61331a3.png";